import { useQuery } from "@tanstack/react-query";
import { documentViewService } from "../services/documentView.service";
import { DocumentViewResponse } from "../types/reportTemplate";

export function useDocumentViewData(
  caseId: string | undefined,
  templateId?: string,
  reportVersion?: number,
  enabled = true
) {
  return useQuery<DocumentViewResponse>({
    queryKey: ["document-view", caseId, templateId, reportVersion],
    queryFn: () =>
      documentViewService.fetchDocumentViewData(
        caseId!,
        templateId,
        reportVersion
      ),
    enabled: !!caseId && enabled,
    staleTime: 30_000,
  });
}
